import axios from 'axios';
import { message } from 'ant-design-vue';

axios.defaults.timeout = 1000 * 60 * 5;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_URL;

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';


axios.interceptors.request.use(config => {
    let token = $cookies.get('token');
    token && (config.headers.token = token);
    return config;
}, error => {
    return Promise.reject(error);
})


axios.interceptors.response.use(response => {
    const res = response.data;
    res.headers = response.headers;
    if (res.code != 200 && !(response.config.responseType == "blob")) {
        message.error({content:res.msg, style:{marginTop: '40px'}});
        return res;
    } else {
        return res;
    }

}, error => {
    let {
        response
    } = error;
    if (response) {
        //服务器有返回结果
        switch (response.status) {
            case 500:
                message.error({content:"服务器错误,请联系系统管理员", style:{marginTop: '40px'}});
                break;
            case 404:
                message.error({content:"页面找不到,请联系系统管理员", style:{marginTop: '40px'}});
                break;
            case 401:
                message.error({content:"token失效,请重新登录", style:{marginTop: '40px'}});
            default:
                message.error({content:"服务器错误,请联系系统管理员", style:{marginTop: '40px'}});
            }
            return;
        } else {
            
        //服务器没有返回结果
        if (!window.navigator.onLine) {
            message.error({content:"网络连接失败", style:{marginTop: '40px'}});
            return;
        }
        message.error({content:"访问服务器失败,请联系系统管理员", style:{marginTop: '40px'}});

        return Promise.reject(error);
    }
})

export default axios;